import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=4ddad788&scoped=true"
import script from "./ColorSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=4ddad788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddad788",
  null
  
)

export default component.exports